import { render, staticRenderFns } from "./Fire.vue?vue&type=template&id=3fb28b95&"
import script from "./Fire.vue?vue&type=script&lang=js&"
export * from "./Fire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports